import { useThrottledValue } from '@tanstack/react-pacer';
import type { LngLatLike } from '@vis.gl/react-maplibre';
import { useMap } from '@vis.gl/react-maplibre';
import type { Point } from 'geojson';
import { useEffect } from 'react';

import { MAP_FLY_TO_ZOOM } from '@/modules/MAP_FLY_TO_ZOOM';
import { useMapStore } from '@/stores/useMapStore';

interface UseMapFlyToProps {
  geometry?: Point;
  enabled?: boolean;
}

export const useMapFlyTo = ({ geometry, enabled = true }: UseMapFlyToProps) => {
  const map = useMap();

  const padding = useMapStore((state) => state.padding);
  const [throttledPadding] = useThrottledValue(padding, { wait: 1000 });

  const longitude = geometry?.coordinates[0];
  const latitude = geometry?.coordinates[1];

  useEffect(() => {
    const center: LngLatLike | undefined =
      longitude !== undefined && latitude !== undefined ? [longitude, latitude] : undefined;

    if (enabled && (center || throttledPadding.bottom > 49)) {
      map.current?.flyTo({
        ...(center !== undefined && {
          center,
          ...(map.current?.getZoom() < MAP_FLY_TO_ZOOM && { zoom: MAP_FLY_TO_ZOOM }),
        }),
        ...(throttledPadding.bottom !== 0 && { padding: { bottom: throttledPadding.bottom, top: 88 } }),
      });
    }
  }, [enabled, latitude, longitude, map, throttledPadding.bottom]);
};
